<!-- ListCellFilter.vue -->
<script setup lang="ts">
  import { defineProps } from 'vue'
  import { ICellFilterProps, INodeData } from '@/types'
  import { Typography } from '@components/index'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<ICellFilterProps>()
  const defaultIcon = props.icon ?? 'arrow-right-square-fill'
  const onClick = props.onClick ?? (() => {})

  const handleClick = () => {
    onClick()
  }

  const isFilterData = (data: any): data is INodeData => {
    return (data as INodeData).details !== undefined
  }
</script>

<template>
  <div
    :id="props.data.id"
    class="cell-wrapper align-items-center px-4 rounded-3"
    @click="handleClick"
  >
    <div
      v-if="isFilterData(props.data) && props.data.parent_titles && props.data.parent_titles.length"
      class="d-flex flex-1 align-items-left pt-2"
    >
      <div class="d-flex">
        <Typography
          v-for="(title, index) in props.data.parent_titles"
          :key="index"
          :variant="
            index === props.data.parent_titles.length - 1 ? 'breadcrumb-current' : 'breadcrumb'
          "
          class="cell-title flex-grow-1"
        >
          <template v-if="index === 0">.../</template>
          {{ title }}
          <template v-if="index < props.data.parent_titles.length - 1">/</template>
        </Typography>
      </div>
    </div>
    <div class="d-flex flex-1 align-items-center">
      <Typography
        variant="bullet-info-title"
        class="cell-title flex-grow-1"
      >
        {{ props.data.title }}
      </Typography>
      <i
        class="cell-icon"
        :class="loadIcon(defaultIcon)"
      />
    </div>
    <div class="pb-3">
      <Typography
        variant="filter-cell-description"
        class="cell-title flex-grow-1"
      >
        {{
          isFilterData(props.data)
            ? props.data.details?.definition.description
            : props.data.description
        }}
      </Typography>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .cell-wrapper {
    cursor: pointer;
    background-color: #2d3034;
    min-height: 76px;
  }

  .cell-title {
    padding-inline: 0px;
  }

  .cell-icon {
    height: 16px;
    width: 16px;
  }
</style>
